import Segment from 'semantic-ui-react/dist/commonjs/elements/Segment';
import '@purple/semantic-ui-purple-theme/components/segment.css';

export default Segment;
